import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface Language {
    code: string;
    name: string;
    flag: string;
}

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const languages: Language[] = [
        { code: 'ro', name: 'Română', flag: '🇷🇴' },
        { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
        { code: 'en', name: 'English', flag: '🇺🇸' },
    ];

    const handleChange = (lng: string) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('language', lng);
    };

    const current = languages.find(l => l.code === i18n.language) || languages[0];

    return (
        <Select
            data-testid="language-selector"
            value={current.code}
            onChange={handleChange}
            style={{ width: 120 }}
            size="small"
            suffixIcon={<GlobalOutlined />}
        >
            {languages.map(lang => (
                <Option key={lang.code} value={lang.code}>
                    <span style={{ marginRight: 8 }}>{lang.flag}</span>
                    {lang.name}
                </Option>
            ))}
        </Select>
    );
};

export default LanguageSelector;
